module.exports = __webpack_public_path__ + "media/images/our_apps/app_store_btn-136c63161cf2d50bd218723f26acd3d9.png";